// 配货单
// import TableList from "@components/templates/tablelist";
import BaseMixin from '@/views/mixin.vue'
// import { HttpGetSupplierProduct, HttpSupplierProductUnactive, HttpSupplierProductActive } from "@/service/purchase/purchase";
import comModifywarehouse from './update/modifywarehouse.vue';
import compSwitchIssueMethod from './update/switchissuemethod.vue';
import comAddNotes from './update/addnotes.vue';
import {
    HttpGetDistribution,
    HttpPickUp,
    HttpPushToWarehouse,
    HttpPushAttach,
    HttpResetOrder,
    HttpRecoverNormal,
    HttpDownloadLabel,
    HttpResubmit,
    HttpGetAllLabel,
    HttpSaveLabel,
    HttpOrderAddLabel,
    HttpOrderRemoveLabel
} from '@/service/boss/distribution'
import { mapState, mapGetters } from "vuex";
import comCancel from './update/cancel'
import comIndex from './update/index'
import orderIndex from './../b2corder/admin/update/index'
import compSearch from './search'
import comImport from './update/compimport.vue';
import mixinList from './mixin'
import comCantract from '../../purchase/order/update/contract'
import compImportUpc from './update/importupc';
import compSendTime from './update/sendtime';
import warehouseMixin from "../b2corder/warehouseMixin";
export default {
    mixins: [BaseMixin, mixinList, warehouseMixin],
    components: {
        comIndex,
        comCancel,
        compSearch,
        orderIndex,
        comModifywarehouse,
        compSwitchIssueMethod,
        comAddNotes,
        comImport,
        comCantract,
        compImportUpc,
        compUpload: () =>  import("@components/templates/upload"),
        compSendTime
        // compSearch,
        // compERPSKU,
        // comProductIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            dataList: [],
            formData: {
                search: {
                    'EQ_status': null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            labelList: []
        };
    },
    created(){
        this.boltemp = this.handleAuth('deliver.order.set');
        this.getLabelData();
        // console.log(this.boltemp)
    },
    methods: {
        httpList: HttpGetDistribution,
        getLabelData () {
            HttpGetAllLabel({
                module: 26
            }).then(res => {
                this.labelList = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async handleLabelChange (changeMap) {
            // console.log('change', changeMap);
            await changeMap.forEach(async (value, key, map) => {
                await HttpSaveLabel({
                    id: key,
                    labelId: value.labelId,
                    labelName: value.labelName
                }).then(res => {
                    this.$VMessage.success(res.message);
                }, err => {
                    this.$VMessage.error(err.message);
                });
            });
            // this.getLabelData();
        },
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear(); 
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear + "-" + tMonth + "-" + tDate;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },
        handleCheck(checkFunc, params) {
            let idArr = params.split(',')
            let needSend = []
            this.dataList.map(item => {
                idArr.map(id => {
                    if (parseInt(id) === item.id) {
                        // if (item.deliverOrderStatus > 1) {
                        if (checkFunc(item)) {
                            return this.$VMessage.error(`${item.deliverOrderNo}` + this.$t('erp.b2c.status_delivery_order',{defaultValue:'配货单状态不符！'}))
                        }
                        needSend.push(item.id)
                    }
                })
            })
            return needSend
        },
        getOperateNodeMap(row) {
            const id = row.id, enable = row.deliverOrderStatus === 0 || row.deliverOrderStatus === 1 || row.deliverOrderStatus === 5
            return [{
                label: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
                show: enable,
                params: id,
                operate: 'cancel'
            }]
        },
        handleLabel (type, labelIds) {
            let params = this.checkedId.join(',')
            if (!this.checkedId.join(',').length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            // console.log(type, labelIds);
            switch (type) {
                case 'add':
                    HttpOrderAddLabel({
                        labelIds: labelIds.join(','),
                        orderIds: params
                    }).then(res => {
                        // console.log(res);
                        this.updateSearch();
                        this.$VMessage.success(res.message);
                    }, err => {
                        this.$VMessage.error(err);
                    })
                    break;
                case 'remove':
                    HttpOrderRemoveLabel({
                        labelIds: labelIds.join(','),
                        orderIds: params
                    }).then(res => {
                        // console.log(res);
                        this.updateSearch();
                        this.$VMessage.success(res.message);
                    }, err => {
                        this.$VMessage.error(err);
                    })
                    break;
            }
        },
        handleDeleteCollect (callback) {
            this.showDel = true;
            this.operate = {
                alert: "error",
                title: this.$t('erp.b2corder.search_modal_delete_query_title', { defaultValue: '删除收藏查询' }),
                desc: this.$t('erp.b2corder.search_modal_delete_query_desc', { defaultValue: '确定删除收藏的查询？' }),
                // ajaxRequest:HttpResetOrder
            }
            this.batchOpearte = () => {
                callback(() => {
                    this.showDel = false;
                })
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedId.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "edit":
                    let url = this.$router.resolve({
                        name: 'distributionQuery',
                        params: {
                            type: 'edit'
                        },
                        query: {
                            id: params
                        }
                    });
                    window.open(url.href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        title: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                        show: true,
                        component: 'comCancel',
                        activeid: params,
                        showFooter: false
                    }
                    break
                case 'pushWarehouse':
                    this.showDel = true;
                    this.operate = {
                        alert: "error",
                        params: { deliverOrderIds: params },
                        title: this.$t("erp.b2c.pushyuncang", { defaultValue: "推送仓库" }),
                        desc: this.$t('erp.b2c.pushyuncang_alert'),
                        // ajaxRequest:HttpResetOrder
                    }
                    this.batchOpearte = () => {
                        this.pushWarehouse(params, () => {
                            this.showDel = false;
                        });
                    }
                    break;
                case 'pushAgain':
                    this.showDel = true;
                    this.operate = {
                        alert: "error",
                        params: { deliverOrderIds: params },
                        title: this.$t("erp.distribution.pushfile", {
                            defaultValue: "附件推送",
                        }),
                        desc: this.$t('erp.distribution.pushfile_alert'),
                        // ajaxRequest:HttpResetOrder
                    }
                    this.batchOpearte = () => {
                        this.pushAgain(params, () => {
                            this.showDel = false;
                        })
                    }
                    break
                case "queryBlank":
                    window.open(this.$router.resolve({
                        name: 'distributionQuery',
                        params: { type: "query" },
                        query: { id: params },
                    }).href, '_blank')
                    break;
                case "queryOrder":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "orderIndex",
                        activeids: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "pickup":
                    this.showDel = true;
                    this.batchOpearte = () => {
                        HttpPickUp({
                            contextId: global.SYSID,
                            deliverOrderIds: params
                        }).then(res => {
                            this.$VMessage.success(res.message);
                            this.showDel = false;
                            this.updateSearch();
                        }, err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                            this.showDel = false;
                        })
                    }
                    this.operate = {
                        // show: true,//显示弹框
                        width: 500, //弹框宽度
                        alert: 'error',//简洁模式主题和component模式互斥，
                        params: {
                            contextId: global.SYSID,
                            deliverOrderIds: params
                        },//接口参数
                        desc: this.$t('erp.distribution.pickup_modal_desc', { defaultValue: 'Are you sure to pickup?' }),
                        showDesc: true,//不显示描述，
                        title: this.$t('erp.distribution.pickup_modal_title', { defaultValue: 'Pickup' }),//标题
                    }
                    break;
                // 重置配货单
                case 'resetOrder':
                    this.showDel = true;
                    this.operate = {
                        alert: "error",
                        params: { deliverOrderIds: params },
                        title: this.$t('erp.disturibution.reset_order', { defaultValue: '重置配货单' }),
                        desc: this.$t('erp.disturibution.reset_order_alert'),
                        // ajaxRequest:HttpResetOrder
                    }
                    this.batchOpearte = () => {
                        HttpResetOrder({
                            deliverOrderIds: params
                        }).then(res => {
                            this.$VMessage.success(res.message);
                            this.updateSearch();
                            this.showDel = false;
                        }, err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                            this.showDel = false;
                        })
                    }
                    break;
                // 恢复正常
                case 'recovery':
                    this.showDel = true;
                    this.operate = {
                        alert: "error",
                        params: { deliverOrderIds: params },
                        title: this.$t("erp.b2c.back_normal", { defaultValue: "恢复正常" }),
                        desc: this.$t("erp.b2c.back_normal_alert")
                        // ajaxRequest:HttpResetOrder
                    }
                    this.batchOpearte = () => {
                        HttpRecoverNormal({
                            deliverOrderIds: params
                        }).then(res => {
                            this.$VMessage.success(res.message);
                            this.updateSearch();
                            this.showDel = false;
                        }, err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                            this.showDel = false;
                        })
                    }
                    break;
                // 重新提交
                case 'resubmit':
                    this.showDel = true;
                    this.operate = {
                        alert: "error",
                        params: { deliverOrderIds: params },
                        title: this.$t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        }),
                        desc: this.$t("erp.distribution.resubmit_alert")
                        // ajaxRequest:HttpResetOrder
                    }
                    this.batchOpearte = () => {
                        HttpResubmit({
                            deliverOrderIds: params
                        }).then(res => {
                            this.$VMessage.success(res.message);
                            this.updateSearch();
                            this.showDel = false;
                        }, err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                            this.showDel = false;
                        })
                    }
                    break;
                // 下载面单
                case 'downloadLabel':
                    HttpDownloadLabel({
                        deliverOrderIds: params
                    }).then(res => {
                        this.$VMessage.success(res.message);
                        this.updateSearch();
                    }, err => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    })
                    break;
                // 修改仓库物流
                case 'modifylogistics':
                    this.operate = {
                        title: this.$t('erp.b2c.modify_logistics',{defaultValue:'修改仓库物流'}),
                        show:true,
                        width:600,
                        component: "comModifywarehouse",
                        activeids:this.checkedId,
                    }
                    break;
                // 切换出库方式
                case 'switchissuemethod': {
                    this.checkedId = !params ? this.checkedId : [params];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.switch_issue_method', { defaultValue: '切换出库方式' }),
                        component: "compSwitchIssueMethod",
                        activeids:this.checkedId,
                        showFooter: false,
                        on: {
                            'on-update': (res) => {
                                this.updateSearch();
                            },
                        }
                    }
                    break;
                }
                // 添加备注
                case 'addnotes':
                    this.operate = {
                        title: this.$t('erp.b2c.add_notes',{defaultValue:'添加备注'}),
                        show:true,
                        width:600,
                        component: "comAddNotes",
                        activeids:this.checkedId,
                    }
                    break;
                // 取消
                case 'batchCancel':
                    this.operate = {
                        title: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                        show: true,
                        component: 'comCancel',
                        activeid: params,
                        showFooter: false
                    }
                    break;
                // 附件上传
                case 'wordImport':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.arrachement_upload',{defaultValue:'附件上传'}),
                        width:460,
                        showFooter: false,
                        actionurl: "/api/v2/DeliverOrder/uploadAttach",
                        name: "excelFile",
                        comptitle:this.$t('erp.b2c.attachment_type',{defaultValue:'附件类型'}),
                        component: "comImport",
                        warningtitle:this.$t('erp.distribution.arrachement_tip'),
                    }
                break;
                // UPC导入
                case 'upcImport':
                    params = (params || this.checkedId.join(',')) + '';
                    if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                    this.operate = {
                        show: true,
                        title: this.$t('erp.distribution.import_upc',{defaultValue:'UPC导入'}),
                        width:460,
                        showFooter: false,
                        propsData: {
                            data: {
                                deliverOrderIds: params,
                            },
                            multiple: false,
                            action: "/api/v2/DeliverOrder/upcUpload",
                            name: "file",
                            warningtitle: this.$t('erp.distribution.import_upc_text', { defaultValue: '注意' }),
                            formatter (res) {
                                this.$VMessage.success(res.message);
                            }
                        },
                        // comptitle:this.$t('erp.b2c.attachment_type',{defaultValue:'附件类型'}),
                        component: "compImportUpc",
                    }
                break;
                case 'arnImport':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.distribution.import_arn', { defaultValue: 'ARN导入' }),
                        width: 460,
                        showFooter: false,
                        multiple: false,
                        action: "/api/v2/DeliverOrder/arnImport",
                        name: "excelFile",
                        warningtitle: this.$t('erp.distribution.import_arn_remark', { defaultValue: `
                        <div class="pull-left text-left margin-bottom-15">
                        <p>注意：</p>
                        <p>1.导入格式排序：配货单号、ARN、渠道建议发货方式，配货单号必填；</p>
                        <p>2.配货单已经推送仓库的，ARN导入后会自动推送仓库。</p>
                        ` }),
                        formatter (res) {
                            this.$VMessage.success(res.message);
                        },
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/DeliverOrder/arnTemplate', 'download')
                        },
                        // comptitle:this.$t('erp.b2c.attachment_type',{defaultValue:'附件类型'}),
                        // component: "compImportUpc",
                        component: "compMutiUpload",
                    }
                break;
                // 批量修改最晚发货时间
                case 'batchChangeLastestTime':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.distribution.batch_change_lastest_deliver_date',{defaultValue:'修改最晚发货时间'}),
                        width:460,
                        showFooter: false,
                        activeids: params,
                        component: 'compSendTime'
                    }
                break;
                case 'downcontract':
                    this.operate = {
                        title: this.$t('erp.b2c.generate_BOL', { defaultValue: '生成BOL' }),
                        show: true,
                        width: 450,
                        component: "comCantract",
                        activeid: params,
                        querytype: 'query',
                        typedata:'distribution',
                        showFooter: false
                    }
                break;
                case 'trackingImport':
                    this.operate = {
                        show: true,
                        title: 'Tracking' + this.$t('global.common.import',{defaultValue:'导入'}),
                        width:460,
                        showFooter: false,
                        data: { contextId: global.SYSID},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/DeliverOrder/trackingImport",
                        name: "excelFile",
                        component: "compUpload",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/DeliverOrder/trackingImportTemplate','download')
                        },
                        warningtitle: this.$t('erp.b2c.tracking_import'),
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: (row.activeStatus === 0 || row.deliverOrderStatus === 5) && row.labelStatus === 0,
                // show: row.deliverOrderStatus === 0,
                params: id,
                operate: 'edit'
            },
            {
                label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                show: row.deliverOrderStatus === 0 || row.deliverOrderStatus === 1 || row.deliverOrderStatus === 5,
                params: id,
                operate: 'cancel'
            },{
                label: this.$t('erp.b2c.generate_BOL', { defaultValue: '生成BOL' }),
                show: this.boltemp && !(row.deliverOrderStatus === 2 || row.deliverOrderStatus === 3),
                params: id,
                operate: 'downcontract'
            },
            ]
        },
    },
    computed: {

        ...mapGetters('diction', ['getNewAllProductList', 'getNewAllAccountIdList']),
        ...mapGetters('dictionary', ['getOrgList', 'getNewAllWarehouseIdList','getCarrierCusList']),
        ...mapState('boss', ['sysshippingcode']),
        getBind() {
            return {
                on: {
                    'on-query': this.queryChange
                }
            }
        },
        columns() {
            let column = [
                {
                    show: false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                }, {
                    minWidth: 150,
                    title: `${this.$t('erp.distribution.deliverorderno', { defaultValue: '配货单号' })}/${this.$t('global.common.project', { defaultValue: '项目' })}`,
                    // sortable: true,
                    // width: 200,
                    render: (h, { row }) => {
                        let orgName = this.getOrgList.filter(item => {
                            return item.value === row.orgId
                        })[0]
                        let productItem = this.getNewAllProductList.filter(item => {
                            return item.value === row.lineId
                        })[0]
                        let urgent = row.systemShipServiceLevel !== 0;
                        let isActive = row.activeStatus !== 1;
                        return (
                            <div>
                                <div>
                                    <span>{orgName ? orgName.label : '--'}</span>
                                    <Tooltip placement="top" content={this.$t('erp.b2c.table_urgentorder',{defaultValue:'加急订单（最晚发货时间在24小时内）'})}>
                                        <span style={`cursor: pointer; ${row.systemShipServiceLevel === 0 ? 'display: none; margin-left: 5px;' : 'margin-left: 5px;'}`} class="order-urgent-span">{this.$t('erp.b2c.table_urgent', { defaultValue: '急' })}</span>
                                    </Tooltip>
                                    <Tooltip placement="top" content={this.$t('erp.b2c.actived_order',{defaultValue:'待激活订单'})}>
                                        <span style={`cursor: pointer; ${row.activeStatus === 1 ? 'display: none; margin-left: 5px;' : 'margin-left: 5px;'}`} class="order-active-span">{this.$t('erp.b2c.table_active', { defaultValue: '激' })}</span>
                                    </Tooltip>
                                </div>
                                <div>{productItem ? productItem.attach.name : '--'}</div>
                                <div>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.deliverOrderNo}</a>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    minWidth: 150,
                    title: this.$t('erp.b2c.search_ordernumber', { defaultValue: '订单号' }),
                    // width: 180,
                    render: (h, { row }) => {
                        let error = this.distributionException.filter(item => {
                            return item.value == row.errorCode
                        })[0]
                        let errorMes = error ? error : "";
                        // console.log(errorMes);
                        return (
                            <div>
                                <div class="flex-space-between-container">
                                    <a onClick={this.handleOperates.bind(this, row.sourceId, 'queryOrder')}>{row.sourceId}</a>
                                    <span style={row.isSfp === 0 ? 'display: none;' : 'font-size:12px;'} class="b2cfont-italic b2ccolor-info flex-1">Prime</span>
                                </div>
                                <div class="flex-space-between-container">
                                    <span class="flex-1">{row.sourceNo}</span>
                                </div>
                                <div v-show={errorMes && errorMes != undefined}><span class="error-span margin-right-10">{errorMes.label}</span></div>
                            </div>
                        )
                    }
                },
                {
                    // minWidth: 150,
                    minWidth: 110,
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    // width: 90,
                    render: (h, { row }) => {
                        // this.dataList.push({
                        //     id: row.id,
                        //     status: row.deliverOrderStatus
                        // })
                        let dataItem = this.distributionStatus.filter(item => {
                            return item.value === row.deliverOrderStatus
                        })[0]
                        switch (dataItem.value) {
                            case 0: return <Button class="b2cspan-success span-padding">{this.$t('erp.distribution.created', { defaultValue: '已创建' })}</Button>; break;
                            case 1: return <Button class="b2cspan-info span-padding">{this.$t('erp.distribution.pushed', { defaultValue: '已推送' })}</Button>; break;
                            case 2: return <Button class="b2cspan-light-content span-padding">{this.$t('erp.b2c.orderstatus_shipped', { defaultValue: '已发货' })}</Button>; break;
                            case 3: return <Button class="b2cspan-warning span-padding">{this.$t('global.common.canceled', { defaultValue: '已取消' })}</Button>; break;
                            case 5: return <Button class="b2cspan-dark-primary span-padding">{this.$t("fbb.headlogistics.draft", { defaultValue: "草稿"})}</Button>; break;
                        }
                    }
                },
                {
                    title: 'ERP SKU',
                    minWidth:150,
                    render: (h, { row }) => {

                        let erpsku = row.deliverOrderItemEntityList.map(item=>{
                            let html = <div>{item.erpsku} * {item.qty}</div>
                            return html
                        })
                        return <div>
                            <div >{erpsku}</div>
                        </div>
                    },

                },
                {
                    minWidth: 210,
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    align: 'center',
                    render: (h, { row }) => {
                        let dataItem = this.getNewAllAccountIdList.filter(item => {
                            return item.value === row.channelId
                        })[0];
                        // console.log(dataItem);
                        return (
                            <div>
                                <div>{dataItem ? `${dataItem.label}` : '--'}</div>
                            </div>
                        )
                    }
                },
                // {
                //     minWidth: 150,
                //     title: this.$t('global.common.project', { defaultValue: '项目' }),
                //     align: 'center',
                //     render: (h, { row }) => {
                //         let productItem = this.getNewAllProductList.filter(item => {
                //             return item.value === row.lineId
                //         })[0]
                //         return (
                //             <div>
                //                 <div>{productItem ? productItem.attach.name : '--'}</div>
                //             </div>
                //         )
                //     }
                // },
                {
                    minWidth: 150,
                    title: this.$t('erp.distribution.wareservice', { defaultValue: '发货仓库/发货方式' }),
                    // width: 150,
                    render: (h, { row }) => {
                        const className = row.outboundMode == 1 || row.outboundMode == 2 ? 'iconfont icon-tuopan_pallet' : row.outboundMode == 0 ? 'iconfont icon-kuaidi' : '';
                        const descriptionName = row.outboundMode == 1 ? this.$t('erp.b2c.goods_collection_tooltip',{defaultValue:'集货出库-不上报打托信息'}) : row.outboundMode == 0 ? this.$t('erp.b2c.direct_issue_tooltip',{defaultValue:'直接出库'}) :  row.outboundMode == 2 ? this.$t('erp.b2c.goods_collection_underpinning_tooltip',{defaultValue:'集货出库-上报打托信息'}) :'';
                        let dataItem = this.warehouseList.filter(item => {
                            return item.value === row.orgWarehouseId
                        })[0]
                        return (
                            <div>
                                <div>{dataItem ? dataItem.label : '--'}</div>
                                <div>{row.customerCarrierServiceCode ? row.customerCarrierServiceCode : '--'} </div>
                                {/* ({this.findRenderLabel(this.getCarrierCusList, row.carrierAccountGroupId) || '--'}) */}
                                <Tooltip placement="top" content={descriptionName}>
                                    <div style="font-size: 16px; color: #00adff" class={className}></div>
                                </Tooltip>
                            </div>
                        );
                    }
                },
                {
                    minWidth: 110,
                    title: this.$t('erp.b2c.package_logistics_status', { defaultValue: '物流状态' }),
                    // width: 110,
                    render: (h, { row }) => {
                        let status = row.saleShipmentPackagesList[0] == undefined ? -1 : row.saleShipmentPackagesList[0].logisticStatus;
                        let dataItem = this.packStatus.filter(item => {
                            return item.value === status
                        })[0];
                        return <div>{dataItem ? dataItem.label : '--'}</div>;
                    }
                },
                {
                    minWidth: 100,
                    title: this.$t('erp.distribution.ispickup', { defaultValue: '是否可提货' }),
                    render: (h, { row }) => {
                        const statusObj = {
                            1: this.$t('erp.distribution.pickup', { defaultValue: '是' }),
                            0: this.$t('erp.distribution.nopickup', { defaultValue: '否' })
                        }
                        return <div>{statusObj[row.pickupStatus]}</div>
                    }
                },
                {
                    minWidth: 150,
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                    sortable: true,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.createdAt}</div>
                            </div>
                        )
                    }
                },
                {
                    minWidth: 150,
                    title: this.$t('erp.b2c.latest_time', { defaultValue: '最晚发货时间' }),
                    key: 'createdAt',
                    sortable: true,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.latestShipDate}</div>
                            </div>
                        )
                    }
                },
                {
                    minWidth: 150,
                    title: this.$t('erp.distribution.warehouse_expect_lastest_time', { defaultValue: '仓库预计发货时间' }),
                    key: 'createdAt',
                    sortable: true,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.warehouseLastOutboundDate}</div>
                            </div>
                        )
                    }
                }
            ];
            // 仅梦百合可见是否可提货
            if (global.SYSID !== 1000147) {
                column.splice(9, 1);
            }
            return column;
        },

    }

};
